import controller from './login.controller';
import templateBase from './templates/login-base.view.html';
import templateT1 from './templates/login-t1.view.html';
import templateT11 from './templates/login-t11.view.html';
import templateAD from './templates/login-adaptative.html';

let LoginComponent = {
  template : changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    rPass:'@'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  } else {
    if(response.LOGIN.component == 'template_t1'){ return templateT1; }
    if(response.LOGIN.component == 'template_t11'){ return templateT11; }
    else{
      return templateBase;
    }
  }
}

export default LoginComponent;


// WEBPACK FOOTER //
// ./www/components/login/login.component.js